<template>
  <div class="receive-chart-wrap">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Select
          placeholder="搜索客户"
          v-model="selectedCustomer"
          label-in-value
          clearable
          filterable
          :remote-method="chooseCustomer"
          @on-change="changeCustomer"
          style="width: 220px; margin-right: 30px"
        >
          <Option
            v-for="item in customersSimple"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          placeholder="筛选公司"
          v-model="company"
          label-in-value
          clearable
          @on-change="chooseCompany"
          style="width: 180px; margin-right: 30px"
        >
          <Option
            v-for="item in companyList"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 200px"
          v-model="month"
          @on-change="changeDate"
        />
      </div>
      <div class="handle-right"></div>
    </div>
    <div class="list-chart-wrap">
      <div class="receive-list-wrap" ref="tableWrapper">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="20"
            @on-change="loadReceive"
            show-total
            simple
          />
        </div>
        <div class="receive-list" :style="tableHeight">
          <div class="receive-item" v-for="item in receiveList">
            <Card>
              <div class="item-info customer-price">
                <div class="customer">{{ item.from.name }}</div>
                <div
                  class="price"
                  :style="{ color: item.amount ? 'black' : '#a1a3a6' }"
                >
                  {{
                    item.amount
                      ? numDeal(item.amount)
                      : numDeal(item.submitAmount)
                  }}
                </div>
              </div>
              <div class="item-info by-type">
                <div class="receiveBy">{{ item.receivedBy.name }}</div>
                <div class="receiveType">{{ typeToTextMethod(item.type) }}</div>
              </div>
            </Card>
          </div>
        </div>
      </div>
      <div class="receive-chart">
        <div id="receiveDailyChart" style="width: 1200px; height: 400px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
} from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
]);

import dayjs from "dayjs";
const typeToText = {
  trans: "银行转账",
  bankAccBill: "银承",
  commAccBill: "商承",
  check: "支票",
  cash: "现金钞票",
  yun: "云信通",
  jian: "建信融通",
  bankAccBillPaper: "纸质银承",
  gold: "金单",
  sywx: "商银微芯",
  ji: "集信",
  zhu: "筑信",
};
export default {
  name: "ReceiveChart",
  data() {
    return {
      tableHeight: {
        height: "300px",
      },
      receiveDailyChart: null,
      receiveDailyChartOption: null,
      limit: 20,
      page: 0,
      selectedCustomer: null,
      filterQuery: {
        startDate: null,
        endDate: null,
        groupBy: "day",
      },
      invalid: null,
      company: null,
      chartDateArray: [],
      receiveChartData: {
        trans: [],
        bankAccBill: [],
        commAccBill: [],
        check: [],
        cash: [],
        yun: [],
        jian: [],
        totalAmount: [],
      },
      month: null,
    };
  },
  computed: mapState({
    receiveList: (state) => state.receive.receiveList,
    totalRows: (state) => state.receive.totalCounts,
    currentUser: (state) => state.auth.currentUser,
    companyList: (state) => state.company.companyList,
    user: (state) => state.auth.currentUser,
    customerId: (state) => state.customer.detailCustomersId,
    customersSimple: (state) => state.customer.customersSimple,
  }),
  methods: {
    ...mapActions({
      getReceiveStat: "receive/getReceiveStatAction",
      deleteReceive: "receive/deleteReceiveAction",
      getReceiveById: "receive/getReceiveByIdAction",
      getReceive: "receive/getReceiveAction",
      getCompanyList: "company/getCompanyListAction",
      getSimpleBankAccount: "bankAccount/getSimpleBankAccountAction",
      getSimpleUserList: "user/getSimpleUserListAction",
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
    }),
    numDeal(e) {
      return e.toLocaleString();
    },
    typeToTextMethod(e) {
      return typeToText[e];
    },
    async loadReceiveChart(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      this.receiveChartData = {
        trans: [],
        bankAccBill: [],
        commAccBill: [],
        check: [],
        cash: [],
        yun: [],
        jian: [],
        totalAmount: [],
      };
      try {
        const data = await this.getReceiveStat(this.filterQuery);
        const receiveStat = data.receiveStat;
        const startAt = dayjs(this.filterQuery.startDate);
        const endAt = dayjs(this.filterQuery.endDate);
        const daysCount = endAt.diff(startAt, "day") + 1;
        if (this.chartDateArray.length > 1) {
          this.chartDateArray = this.chartDateArray.splice(
            this.chartDateArray.length
          );
        }
        for (let i = 0; i < daysCount; i++) {
          const currentDate = startAt.add(i, "day");
          this.chartDateArray.push(dayjs(currentDate).format("M/D"));
          const currentDateText = dayjs(currentDate).format("YYYY-MM-DD");
          const receiveData = receiveStat.find((v) => {
            const receiveDate = dayjs()
              .year(v._id.year)
              .month(v._id.month - 1)
              .date(v._id.day);
            const receiveDateText = dayjs(receiveDate).format("YYYY-MM-DD");
            return receiveDateText === currentDateText;
          });

          if (receiveData) {
            this.receiveChartData.bankAccBill.push(
              (receiveData.bankAccBill / 10000).toFixed(0)
            );
            this.receiveChartData.trans.push(
              (receiveData.trans / 10000).toFixed(0)
            );
            this.receiveChartData.commAccBill.push(
              (receiveData.commAccBill / 10000).toFixed(0)
            );
            this.receiveChartData.check.push(
              (receiveData.check / 10000).toFixed(0)
            );
            this.receiveChartData.cash.push(
              (receiveData.cash / 10000).toFixed(0)
            );
            this.receiveChartData.yun.push(
              (receiveData.yun / 10000).toFixed(0)
            );
            this.receiveChartData.jian.push(
              (receiveData.jian / 10000).toFixed(0)
            );
            this.receiveChartData.totalAmount.push(
              (receiveData.totalAmount / 10000).toFixed(0)
            );
          } else {
            this.receiveChartData.bankAccBill.push(0);
            this.receiveChartData.trans.push(0);
            this.receiveChartData.commAccBill.push(0);
            this.receiveChartData.check.push(0);
            this.receiveChartData.cash.push(0);
            this.receiveChartData.yun.push(0);
            this.receiveChartData.jian.push(0);
            this.receiveChartData.totalAmount.push(0);
          }
        }
        this.receiveDailyChartOption.xAxis[0].data = this.chartDateArray;
        this.receiveDailyChartOption.series[0].data =
          this.receiveChartData.totalAmount;
        this.receiveDailyChartOption.series[1].data =
          this.receiveChartData.trans;
        this.receiveDailyChartOption.series[2].data =
          this.receiveChartData.bankAccBill;
        this.receiveDailyChartOption.series[3].data =
          this.receiveChartData.commAccBill;
        this.receiveDailyChartOption.series[4].data =
          this.receiveChartData.check;
        this.receiveDailyChartOption.series[5].data =
          this.receiveChartData.cash;
        this.receiveDailyChartOption.series[6].data = this.receiveChartData.yun;
        this.receiveDailyChartOption.series[7].data =
          this.receiveChartData.jian;
        this.reloadChart();
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
      }
    },
    async loadReceive(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      try {
        await this.getReceive(this.filterQuery);
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
      }
    },
    async chooseCustomer(query) {
      this.page = 0;
      if (query !== "") {
        this.customerLoading = true;
        await this.getCustomerSimpleList({ name: query });
        this.customerLoading = false;
      }
    },
    changeCustomer() {
      if (this.selectedCustomer) {
        this.filterQuery.customer = this.selectedCustomer;
        this.loadReceiveChart();
        this.loadReceive();
      }
    },
    async chooseCompany(company) {
      if (company) {
        this.filterQuery.company = company.value;
      } else {
        delete this.filterQuery.company;
      }
      await this.loadReceiveChart();
      await this.loadReceive();
    },
    changeDate(e) {
      const date = new Date(e);
      this.filterQuery.startDate = dayjs(
        new Date(date.getFullYear(), date.getMonth(), 1)
      ).format("YYYY-MM-DD");
      this.filterQuery.endDate = dayjs(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");
      this.loadReceiveChart();
      this.loadReceive();
    },
    drawChart() {
      this.receiveDailyChart = echarts.init(
        document.getElementById("receiveDailyChart")
      );
      this.receiveDailyChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: [
            "银行转账",
            "银承",
            "商承",
            "支票",
            "现金钞票",
            "云信通",
            "建信融通",
          ],
        },
        grid: {
          top: "20%",
          right: "5%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            name: "日",
            type: "category",
            axisLabel: {
              interval: 0,
            },
            data: this.chartDateArray,
          },
        ],
        yAxis: [
          {
            name: "回款金额",
            type: "value",
          },
        ],
        series: [
          {
            name: "总计",
            type: "bar",
            barWidth: 20,
            label: {
              show: true,
              position: "top",
              formatter: "{c}",
              color: "#000",
            },
            itemStyle: {
              color: "rgba(128, 128, 128, 0)", // 设置背景颜色为透明
            },
            barGap: "-100%",
            data: this.receiveChartData.totalAmount,
          },
          {
            name: "银行转账",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.trans,
          },
          {
            name: "银承",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.bankAccBill,
          },
          {
            name: "商承",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.commAccBill,
          },
          {
            name: "支票",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.check,
          },
          {
            name: "现金钞票",
            type: "bar",
            barWidth: 20,
            stack: "Ad",
            data: this.receiveChartData.cash,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "云信通",
            type: "bar",
            barWidth: 20,
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.yun,
          },
          {
            name: "建信融通",
            type: "bar",
            stack: "Ad",
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            data: this.receiveChartData.jian,
          },
        ],
      };
    },
    reloadChart() {
      this.receiveDailyChart.setOption(this.receiveDailyChartOption, {
        notMerge: true,
      });
    },
  },
  async created() {
    let date = new Date();
    this.filterQuery.startDate = dayjs(new Date().setDate(1)).format(
      "YYYY-MM-DD"
    );
    this.month = dayjs(new Date().setDate(1)).format("YYYY-MM-DD");
    this.filterQuery.endDate = dayjs(
      new Date(date.getFullYear(), date.getMonth() + 1, 0)
    ).format("YYYY-MM-DD");
    this.loadReceiveChart();
    await this.getSimpleUserList({ limit: 99 });
    await this.getSimpleBankAccount({ limit: 99 });
    await this.getCompanyList({ limit: 99 });
    this.loadReceive();
  },
  mounted() {
    this.tableHeight.height = this.$refs.tableWrapper.offsetHeight + "px";
    window.onresize = () => {
      this.tableHeight.height = this.$refs.tableWrapper.offsetHeight + "px";
    };
    this.drawChart();
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.receive-item
  /deep/.ivu-card-body
    padding 8px !important

.handle-wrapper
  margin 4px 16px

.list-chart-wrap
  display flex
  margin 4px 16px 0 16px
  height calc(100% - 32px)

.receive-list-wrap
  margin-bottom 30px
  min-width 320px

.page-wrap
  padding 8px
  display flex
  align-items center
  justify-content space-between

.receive-list
  overflow-y auto

  .item-info
    display flex
    justify-content space-between

    .customer
      width 200px
      white-space nowrap
      overflow hidden
      text-overflow ellipsis

  .customer-price
    font-size 18px

  .by-type
    color darkgray
</style>